import React, {FC} from 'react';

import {IntegrationModel} from '../../../../models/api/integrationModel';
import {IntegrationEnabledBannerContainer} from './integrationEnabledBannerContainer';

/*
 * Props.
 */

interface IntegrationEnabledBannersProps {
  integrations: ReadonlyArray<IntegrationModel>;
}

/*
 * Component.
 */

export const IntegrationEnabledBanners: FC<IntegrationEnabledBannersProps> = (props) => (
  <>
    {props.integrations.map((integration) => (
      <IntegrationEnabledBannerContainer integration={integration} />
    ))}
  </>
);
